import React from 'react';
import CalculateIcon from '@mui/icons-material/Calculate';
import CalculationMethodsGuide, { METHODS_GUIDE_TOC } from '../components/calculator/CalculationMethodsGuide';
import { GuidePageShell } from '../components/guide/GuideLayout';
import '../styles/guide-page.css';

/** Standalone — Hesaplama Yöntemleri Rehberi */
const CalculationMethodsGuidePage = () => (
  <GuidePageShell
    badge="Referans · hype CRO"
    title="Hesaplama Yöntemleri Rehberi"
    subtitle="Bayesian, Z-Test, Chi-Squared ve sample size hesaplamalarının formülleri, karşılaştırmaları ve en iyi uygulamalar."
    toc={METHODS_GUIDE_TOC}
    footerActions={[
      { label: 'AB Test Hesaplayıcı', to: '/calculator', icon: <CalculateIcon /> },
      { label: 'Metrik Rehberi', to: '/calculation-guide', variant: 'outlined' },
    ]}
  >
    <CalculationMethodsGuide />
  </GuidePageShell>
);

export default CalculationMethodsGuidePage;
